import {
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from '../common/http/lib';
import {
  FORM_RESPONSE_REST_API_URL,
  FORM_RESPONSE_REST_PUBLIC_API_URL,
  FORM_RESPONSE_STATUS,
} from '../constants';
import type { FormResponse, FormResponseHydrated } from '../types/FormResponse';

const getFormResponse = async (
  formResponseId: string,
): Promise<FormResponseHydrated> =>
  getRequest(`${FORM_RESPONSE_REST_API_URL}/${formResponseId}`).then(
    response => response.data,
  );

const getFormResponseUploadedFiles = async (
  formResponseId: string,
  fieldId: string,
): Promise<FormResponseHydrated> =>
  getRequest(
    `${FORM_RESPONSE_REST_API_URL}/${formResponseId}/field/${fieldId}/uploaded-files`,
  ).then(response => response.data);

const createFormResponse = async (
  fileRequestURL: string,
  formVersionId: string,
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  values: any,
  authenticated: boolean = true,
): Promise<FormResponse> =>
  postRequest(
    `${
      authenticated
        ? FORM_RESPONSE_REST_API_URL
        : FORM_RESPONSE_REST_PUBLIC_API_URL
    }`,
    {
      fileRequestURL,
      formVersionId,
      values,
    },
  ).then(response => response.data);

const fetchToken = async (
  fileRequestURL: string,
  formResponseKey: string,
  authenticated: boolean = true,
): Promise<FormResponse> =>
  getRequest(
    `${
      authenticated
        ? FORM_RESPONSE_REST_API_URL
        : FORM_RESPONSE_REST_PUBLIC_API_URL
    }/${formResponseKey}:fetchToken?fileRequestURL=${fileRequestURL}`,
  ).then(response => response.data);

const patchFileId = async (
  formResponseKey: string,
  formVersionId: string,
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  payload: any,
  authenticated: boolean = true,
): Promise<FormResponse> =>
  putRequest(
    `${
      authenticated
        ? FORM_RESPONSE_REST_API_URL
        : FORM_RESPONSE_REST_PUBLIC_API_URL
    }/${formResponseKey}:file?formVersionId=${formVersionId}`,
    payload,
  ).then(response => response.data);

const patchFileIds = async (
  formResponseKey: string,
  formVersionId: string,
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  payload: Array<any>,
  authenticated: boolean = true,
): Promise<FormResponse> =>
  putRequest(
    `${
      authenticated
        ? FORM_RESPONSE_REST_API_URL
        : FORM_RESPONSE_REST_PUBLIC_API_URL
    }/${formResponseKey}:files?formVersionId=${formVersionId}`,
    payload,
  ).then(response => response.data);

const completeFormResponse = async (
  formResponseKey: string,
  formVersionId: string,
  authenticated: boolean = true,
): Promise<FormResponse> => {
  return patchRequest(
    `${
      authenticated
        ? FORM_RESPONSE_REST_API_URL
        : FORM_RESPONSE_REST_PUBLIC_API_URL
    }/${formResponseKey}?formVersionId=${formVersionId}`,
    {},
    { status: FORM_RESPONSE_STATUS.COMPLETE },
  ).then(response => response.data);
};

const deleteFormResponse = async (formResponseId: string): Promise<void> => {
  return deleteRequest(`${FORM_RESPONSE_REST_API_URL}/${formResponseId}`);
};

const FormResponseAPI = {
  getFormResponse,
  getFormResponseUploadedFiles,
  createFormResponse,
  patchFileId,
  patchFileIds,
  completeFormResponse,
  deleteFormResponse,
  fetchToken,
} as const;

export default FormResponseAPI;
